var _g, _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCriticalIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 36,
    viewBox: "0 0 35 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1536_9587)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 3.43381,
    y: 0.00012207,
    width: 28.8038,
    height: 30.113,
    rx: 3.92779,
    fill: "#C1121F"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.0545 21.063L19.4558 6.80276C19.1171 6.24097 18.4991 5.89197 17.8431 5.89197C17.187 5.89197 16.5691 6.24097 16.2302 6.8028L7.63158 21.063C7.28147 21.6437 7.27112 22.3712 7.60452 22.9616C7.938 23.552 8.56632 23.9188 9.24435 23.9188H26.4418C27.1198 23.9188 27.7481 23.552 28.0816 22.9616C28.415 22.3711 28.4047 21.6436 28.0545 21.063ZM26.8932 22.2905C26.848 22.3704 26.7824 22.4369 26.7031 22.4831C26.6237 22.5294 26.5336 22.5539 26.4418 22.554H9.24435C9.15253 22.5539 9.06237 22.5295 8.98307 22.4832C8.90377 22.4369 8.83817 22.3704 8.79294 22.2905C8.74786 22.2105 8.7248 22.12 8.7261 22.0282C8.7274 21.9364 8.75302 21.8465 8.80036 21.7678L17.3991 7.50756C17.4454 7.43124 17.5106 7.3681 17.5883 7.3242C17.6661 7.28029 17.7538 7.25709 17.8431 7.25682C18.0237 7.25682 18.1938 7.35291 18.287 7.50756L26.8857 21.7678C26.9331 21.8465 26.9587 21.9363 26.96 22.0281C26.9614 22.1199 26.9383 22.2105 26.8932 22.2905Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8492 11.5073C17.3301 11.5073 16.9249 11.7859 16.9249 12.2798C16.9249 13.7866 17.1021 15.9518 17.1021 17.4587C17.1022 17.8512 17.4441 18.0158 17.8493 18.0158C18.1532 18.0158 18.5837 17.8512 18.5837 17.4587C18.5837 15.9519 18.7609 13.7866 18.7609 12.2798C18.7609 11.7859 18.3431 11.5073 17.8492 11.5073ZM17.862 18.8895C17.3048 18.8895 16.8869 19.3326 16.8869 19.8645C16.8869 20.3837 17.3048 20.8395 17.862 20.8395C18.3811 20.8395 18.8243 20.3837 18.8243 19.8645C18.8243 19.3326 18.3811 18.8895 17.862 18.8895Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1536_9587",
    x: 0.815283,
    y: 0.00012207,
    width: 34.0408,
    height: 35.3501,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.61852
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.30926
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1536_9587"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1536_9587",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCriticalIcon);
export default __webpack_public_path__ + "static/media/CriticalIcon.f752099bc0674fb9ec57e502fd84a429.svg";
export { ForwardRef as ReactComponent };